<template>
  <div v-show="show" class="pc__header-banner" @click="handleTopBannerClick">
    <img v-if="headerImage?.imageUrl" v-lazy="$cvWebpFn(headerImage.imageUrl, { h: 70 })" alt="">
  </div>
</template>

<script setup lang="ts">
import { buildBannerSource, filterBanners, buildBannerIdNameSourceValue } from '~/plugins/utils'
import { resolveCurrentPageCode } from '@/utils/traffic-source'

const { $tz, $hotKeysJump } = useNuxtApp()

const headerImage = ref<IBanner>()
const show = ref<boolean>(false)
onMounted(() => {
  const topBanner = useGlobalJsonData().value?.banner_app_v2?.data?.topBanner || []
  const headImg = filterBanners(topBanner)
  
  if(headImg.length > 0 ) {
    headerImage.value = headImg[0]
    show.value = true
  }
})

const handleTopBannerClick = () => {
  const item = headerImage.value!
  const { configType, value } = item
  const source = buildBannerSource(
    'headerTopBanner',
    buildBannerIdNameSourceValue(item),
    resolveCurrentPageCode() || 'home',
    configType
  )
  $hotKeysJump({ linkType: configType, linkValue: value }, true, source)
}
</script>

<style lang="scss" scoped>
.pc__header-banner{
  width: 100%;
  text-align: center;
  padding-bottom: 3.64%;
  position: relative;
  height: 0;
  img{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}
</style>